/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  path {
    fill: ${theme.color.themeTxt};
  }
`
export default class MoneyBagIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" css={Color}>
          <g transform="translate(-31)">
            <g transform="translate(31 0)">
              <path d="M54.265,11.476A2.91,2.91,0,0,0,55,9.563a3.106,3.106,0,0,0-1.721-2.7L57.2,1.635A.947.947,0,0,0,57.257.555,1.233,1.233,0,0,0,56.2,0H53.951A6.213,6.213,0,0,0,50.81.836L49,1.9,47.19.836A6.213,6.213,0,0,0,44.049,0H41.8a1.233,1.233,0,0,0-1.057.555A.947.947,0,0,0,40.8,1.635l3.923,5.229A3.106,3.106,0,0,0,43,9.563a2.91,2.91,0,0,0,.735,1.913C36.047,14.407,31,21.074,31,28.547,31,32.657,34.768,36,39.4,36H58.6c4.632,0,8.4-3.343,8.4-7.453C67,21.074,61.953,14.407,54.265,11.476ZM44.029,2.109h.02a3.58,3.58,0,0,1,1.81.482l2.476,1.451a1.339,1.339,0,0,0,1.331,0l2.476-1.451a3.58,3.58,0,0,1,1.81-.482h.02L50.754,6.4H47.246ZM52.6,9.563a1.136,1.136,0,0,1-1.2,1.055H46.6a1.136,1.136,0,0,1-1.2-1.055,1.136,1.136,0,0,1,1.2-1.055h4.8A1.136,1.136,0,0,1,52.6,9.563Zm6,24.328H57.249A7.054,7.054,0,0,0,59.8,28.547a1.21,1.21,0,0,0-2.4,0c0,2.947-2.692,5.344-6,5.344H46.6c-3.308,0-6-2.4-6-5.344a1.21,1.21,0,0,0-2.4,0,7.054,7.054,0,0,0,2.551,5.344H39.4c-3.308,0-6-2.4-6-5.344,0-7.116,5.161-13.408,12.841-15.658l.553-.162h4.411l.554.162c7.68,2.25,12.84,8.542,12.84,15.658C64.6,31.493,61.908,33.891,58.6,33.891Z" transform="translate(-31 0)" fill="#eee" />
            </g>
            <path d="M-2.047-6.906A5.762,5.762,0,0,0,1.921-8.377V-13.9H-2.428v2H-.262v2.414A2.467,2.467,0,0,1-1.8-9.022c-2.4,0-3.621-1.6-3.621-4.266C-5.42-15.917-4-17.5-1.965-17.5a3.213,3.213,0,0,1,2.4,1.025l1.306-1.554A5.148,5.148,0,0,0-2.047-19.6c-3.257,0-5.87,2.364-5.87,6.4C-7.917-9.121-5.387-6.906-2.047-6.906Z" transform="translate(51.8 36.243)" fill="#eee" />
          </g>
        </svg>
      </Fragment>
    )
  }
}
